import React from 'react';
import {getIcon} from "../service/Icon";

class CategoryLegend extends React.Component {

    static defaultProps = {
        categories: [],
        onClick: () => {}
    }

    render() {



        return (
            <div className="category-legend">
                {this.props.categories.map(category => {
                    return (
                        <div className="category-legend-item" key={'legend_' + category.category_id}>
                            <img src={'/wp-content/plugins/dsz-wordpress-list/map/build/' + getIcon(category.category_slug)} width={20} alt={category.category_title}/>
                            <span>{category.category_title}</span>
                        </div>
                    )
                })}
            </div>
        )
    }

}

export default CategoryLegend;